/**
 * @description  Enum supported by ​/chat​/api​/v1​/client-chat-status
 */

export default Object.freeze({
  WIDGET_OUT_OF_PLANNING: 'WIDGET_OUT_OF_PLANNING',
  WIDGET_NO_AGENT_AVAILABLE: 'WIDGET_NO_AGENT_AVAILABLE',
  WIDGET_OPPORTUNITY: 'WIDGET_OPPORTUNITY',
  ENGAGEMENT_OUT_OF_PLANNING: 'ENGAGEMENT_OUT_OF_PLANNING',
  ENGAGEMENT_NO_AGENT_AVAILABLE: 'ENGAGEMENT_NO_AGENT_AVAILABLE',
  LIVECHAT_SERVED: 'LIVECHAT_SERVED',
})
